'use strict';

import frame from "kernel/iframefactory/Frame";

/**
 * @module iframefactory/IFrameFactory
 * @memberof kernel
 * @description Creates and returns a Frame API for dealing with IFrames
 */
//define(function(require){

	/**
	 * @function create
	 * @description Factory method for creating an IFrame
	 * @instance
	 * @param id {string} Unique IFrame ID
	 * @returns {object} Frame object API containing dom reference getter and styling hooks
	 * @example
	 * var frame = iframefactory.create(); // returns an IFrame Object API
	 * var element = frame.get()  // returns the DOM element directly
	 * frame.hide() // hides the IFrame DOM element
	 * frame.setStyle({"backgroundColor":"#000000"}) // applies CSS Styling to the IFrame
	 */
	function create(id, useContainer){
		if(arguments.length===0){
			throw new Error("IFrameFactory expects a frame id to be passed into constructor");
		} else {
			return frame(id, useContainer);
		}

	}

	export default {
		create:create
	};
//});
